import type { Customer, CustomerStatus } from '@nucleus-commerce/api-client/admin';
import { ApiError } from '@nucleus-commerce/api-client/transport';

/** "Maya Chen", or null when the shopper never gave a name. */
export function customerName(customer: Pick<Customer, 'firstName' | 'lastName'>): string | null {
  const full = [customer.firstName, customer.lastName].filter(Boolean).join(' ').trim();
  return full === '' ? null : full;
}

/**
 * Statuses staff may pick. The API accepts only active and disabled; a guest keeps its own
 * status (it turns active when the shopper sets a password) but can still be disabled.
 */
export function statusChoices(current: CustomerStatus): CustomerStatus[] {
  return current === 'guest' ? ['guest', 'disabled'] : ['active', 'disabled'];
}

/** Disabling ends every session of the shopper, so the dialog asks first. */
export function isDisabling(current: CustomerStatus, next: CustomerStatus): boolean {
  return current !== 'disabled' && next === 'disabled';
}

/** A second record with the same email answers 409 ALREADY_EXISTS; it belongs on the email field. */
export function customerEmailTaken(error: unknown): boolean {
  return error instanceof ApiError && error.code === 'ALREADY_EXISTS';
}

/** The backend's MAX_ADDRESSES_PER_CUSTOMER; one more answers 422 LIMIT_EXCEEDED. */
export const MAX_ADDRESSES = 20;

/** Typed into the delete confirmation; the anonymising deletion cannot be undone. */
export const DELETE_CONFIRMATION = 'DELETE';
